<script>
  import SelecaoBusca from './SelecaoBusca.vue';
  import ItemControleEscolha from './ItemControleEscolha.vue';
  import conciliacaoProjetoServico from '../servico';

  export default {
    components: { SelecaoBusca, ItemControleEscolha },
    props: {
      value: { type: Array, required: true },
      idContaCript: { type: String, required: true },
      idContaAlvo: { type: Number, default: 0 },
      natureza: { type: String, default: 'C' },
      total: { type: Number, default: 0 },
      titulo: { type: String, default: 'Rateio entre projetos' },
      desabilitado: { type: Boolean, default: false },
      aviso: { type: String, default: '' },
      validar: { type: Boolean, default: false },
      opcional: { type: Boolean, default: false },
      projetosLivres: { type: Boolean, default: false },
      comItem: { type: Boolean, default: false },
      comQuantidade: { type: Boolean, default: false },
      consultarItem: { type: Boolean, default: false },
      acompanharTotal: { type: Boolean, default: false },
      idLancamentoIgnorado: { type: Number, default: 0 },
      textoSugestao: { type: String, default: '' },
    },
    data() {
      return { semProjetos: false, verificando: false, alvoVerificado: null, ciLinha: null };
    },
    computed: {
      mostrarItem() { return this.comItem && this.value.some(l => l.exigeItem); },
      mostrarQuantidade() { return this.mostrarItem && this.comQuantidade && this.value.some(l => l.idItem > 0); },
      rateado() {
        return this.arredondar(this.value.reduce((soma, linha) => soma + (+linha.valor || 0), 0));
      },
      saldo() { return this.arredondar(this.total - this.rateado); },
      fechou() { return Math.abs(this.saldo) < 0.005; },
      mensagem() {
        if (this.desabilitado) return '';
        if (this.value.length === 0) return this.opcional ? '' : 'Informe ao menos um projeto.';
        if (this.value.some(l => !l.idProjeto || !l.idRubrica || !l.idSubRubrica))
          return 'Complete projeto, rubrica e subrubrica de todas as linhas.';
        if (this.comItem && this.value.some(l => l.exigeItem && !(l.idItem > 0)))
          return 'Escolha o item de controle das linhas que exigem item.';
        if (this.value.some(l => !((+l.valor || 0) > 0))) return 'O valor de cada linha precisa ser maior que zero.';
        const comErroItem = this.comItem && this.value.find(l => l.idItem > 0 && l.erroItem);
        if (comErroItem) return comErroItem.erroItem;
        if (this.repetida()) return 'Há projeto, rubrica, subrubrica e item repetidos.';
        if (!this.fechou)
          return this.saldo > 0
            ? 'Falta distribuir ' + this.formatar(this.saldo) + '.'
            : 'O rateio passou ' + this.formatar(-this.saldo) + ' do valor.';
        return '';
      },
    },
    watch: {
      total(novo, antigo) {
        if (!this.acompanharTotal || this.arredondar(novo) === this.arredondar(antigo) || this.value.length === 0) return;
        const valor = this.value.length === 1 ? this.arredondar(novo) : 0;
        this.$emit('input', this.value.map(l => {
          const linha = Object.assign({}, l, { valor, valorTexto: valor > 0 ? this.formatar(valor) : '', erroItem: '' });
          if (linha.idItem > 0) this.ajustarQuantidade(linha);
          return linha;
        }));
      },
      idContaAlvo() {
        if (this.value.length > 0) this.$emit('input', []);
        this.verificarProjetos();
      },
      desabilitado() { this.verificarProjetos(); },
    },
    mounted() {
      this.verificarProjetos();
    },
    methods: {
      verificarProjetos() {
        if (this.desabilitado) return;

        if (this.projetosLivres) {
          this.semProjetos = false;
          this.$emit('sem-projetos', false);
          if (this.value.length === 0 && !this.opcional) this.adicionar();
          return;
        }

        if (this.verificando && this.alvoVerificado === this.idContaAlvo) return;

        this.verificando = true;
        this.alvoVerificado = this.idContaAlvo;

        this.buscarProjetos('')
          .then(lista => {
            this.verificando = false;
            this.semProjetos = !lista || lista.length === 0;
            this.$emit('sem-projetos', this.semProjetos);

            if (this.semProjetos) {
              if (this.value.length > 0) this.$emit('input', []);
              return;
            }

            if (this.value.length === 0 && !this.opcional) this.adicionar();
          })
          .catch(() => {
            this.verificando = false;
            if (this.value.length === 0 && !this.opcional) this.adicionar();
          });
      },
      arredondar(valor) { return Math.round((+valor || 0) * 100) / 100; },
      formatar(valor) {
        return (+valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      repetida() {
        const chaves = this.value.filter(l => l.idProjeto && l.idRubrica && l.idSubRubrica)
          .map(l => l.idProjeto + '-' + l.idRubrica + '-' + l.idSubRubrica +
                    '-' + (this.comItem ? (l.idItem || 0) : 0));
        return chaves.some((c, i) => chaves.indexOf(c) !== i);
      },
      adicionar() {
        const sobra = this.arredondar(this.total - this.rateado);
        this.$emit('input', this.value.concat([{
          idProjeto: 0, nomeProjeto: '',
          idRubrica: 0, nomeRubrica: '',
          idSubRubrica: 0, nomeSubrubrica: '',
          idItem: 0, nomeItem: '', exigeItem: false,
          quantidade: 1, quantidadeTexto: '1',
          valor: sobra > 0 ? sobra : 0,
          valorTexto: sobra > 0 ? this.formatar(sobra) : '',
        }]));
      },
      remover(indice) {
        const linhas = this.value.slice();
        linhas.splice(indice, 1);
        this.$emit('input', linhas);
      },
      buscarProjetos(termo) {
        if (this.projetosLivres) return conciliacaoProjetoServico.projetosCredito(termo);

        return conciliacaoProjetoServico.projetosDaConta(this.idContaCript, termo, this.natureza, this.idContaAlvo);
      },
      buscarRubricas(linha, termo) {
        return conciliacaoProjetoServico.rubricasCredito(linha.idProjeto || 0, termo, this.natureza);
      },
      buscarSubrubricas(linha, termo) {
        return conciliacaoProjetoServico.subrubricasCredito(linha.idProjeto || 0, linha.idRubrica || 0, termo, this.natureza);
      },
      limparItem(linha) {
        linha.idItem = 0;
        linha.nomeItem = '';
        linha.exigeItem = false;
        linha.quantidade = 1;
        linha.quantidadeTexto = '1';
        this.$set(linha, 'itemValorUnitario', 0);
        this.$set(linha, 'quantidadeManual', false);
      },
      aoEscolherProjeto(linha, opcao, indice) {
        linha.nomeProjeto = opcao ? opcao.nome : '';
        linha.idRubrica = 0;
        linha.nomeRubrica = '';
        linha.idSubRubrica = 0;
        linha.nomeSubrubrica = '';
        this.limparItem(linha);
        this.preencherSeUnico('rubrica', indice);
      },
      aoEscolherRubrica(linha, opcao, indice) {
        linha.nomeRubrica = opcao ? opcao.nome : '';
        linha.idSubRubrica = 0;
        linha.nomeSubrubrica = '';
        this.limparItem(linha);
        this.preencherSeUnico('subrubrica', indice);
      },
      aoEscolherSubrubrica(linha, opcao) {
        linha.nomeSubrubrica = opcao ? opcao.nome : '';
        this.limparItem(linha);

        if ((!this.comItem && !this.consultarItem) || !linha.idSubRubrica) return;

        conciliacaoProjetoServico
          .itensControle(this.idContaCript, linha.idProjeto || 0, linha.idRubrica || 0, linha.idSubRubrica || 0, '', this.idLancamentoIgnorado)
          .then(resposta => {
            const itens = (resposta && resposta.itens) || [];

            linha.exigeItem = !!(resposta && resposta.exigeItem);

            if (linha.exigeItem && itens.length === 1) {
              linha.idItem = itens[0].id;
              this.aoEscolherItem(linha, itens[0]);
              this.verificarItem(linha);
            }
          })
          .catch(() => { linha.exigeItem = false; });
      },
      aoEscolherItem(linha, opcao) {
        linha.nomeItem = opcao ? opcao.nome : '';
        const porQuantidade = !!opcao && !opcao.controleValorTotal && (+opcao.quantidade || 0) > 0;
        this.$set(linha, 'itemValorUnitario', porQuantidade ? (+opcao.valorUnitario || 0) : 0);
        this.$set(linha, 'quantidadeManual', false);
        this.ajustarQuantidade(linha);
      },
      ajustarQuantidade(linha) {
        if (linha.quantidadeManual) return;
        const unitario = +linha.itemValorUnitario || 0;
        const valor = +linha.valor || 0;
        linha.quantidade = unitario > 0 && valor > 0 ? this.arredondar(valor / unitario) : 1;
        linha.quantidadeTexto = this.formatarQuantidade(linha.quantidade);
      },
      formatarQuantidade(valor) {
        return (+valor || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 });
      },
      abrirCi(linha) {
        if (!linha.idSubRubrica) return;
        this.ciLinha = linha;
      },
      aoEscolherCi(item) {
        const linha = this.ciLinha;
        this.ciLinha = null;
        if (linha.idItem !== item.id) {
          linha.idItem = item.id;
          this.aoEscolherItem(linha, item);
        } else if (!linha.quantidadeManual) {
          this.aoEscolherItem(linha, item);
        }
        this.verificarItem(linha);
      },
      verificarItem(linha) {
        if (!(linha.idItem > 0) || !((+linha.valor || 0) > 0) || this.natureza === 'C') {
          this.$set(linha, 'erroItem', '');
          return;
        }
        const chave = linha.idItem + '|' + linha.valor + '|' + linha.quantidade;
        this.$set(linha, 'chaveItem', chave);
        conciliacaoProjetoServico.verificarItemControle(this.idContaCript, linha, this.natureza, this.idLancamentoIgnorado)
          .then(r => { if (linha.chaveItem === chave) this.$set(linha, 'erroItem', (r && r.mensagem) || ''); })
          .catch(() => {});
      },
      estiloSubrubrica(linha) {
        if (!this.mostrarItem || linha.exigeItem) return {};
        return { gridColumn: 'span ' + (this.mostrarQuantidade ? 3 : 2) };
      },
      tituloCi(linha) {
        if (!linha.idSubRubrica) return 'Escolha a subrubrica antes do item de controle';
        if (linha.erroItem) return linha.erroItem;
        return linha.idItem > 0 ? 'Controle de item: ' + linha.nomeItem : 'Escolher o item de controle';
      },
      preencherSeUnico(nome, indice) {
        this.$nextTick(() => {
          const campos = this.$refs[nome];
          const campo = Array.isArray(campos) ? campos[indice] : campos;
          if (campo) campo.preencherSeUnico();
        });
      },
      aoDigitarQuantidade(linha, evento) {
        linha.quantidadeTexto = evento.target.value;
        linha.quantidade = this.converter(evento.target.value);
        this.$set(linha, 'quantidadeManual', linha.quantidade > 0);
      },
      aoSairDaQuantidade(linha) {
        if (!(linha.quantidade > 0)) {
          this.$set(linha, 'quantidadeManual', false);
          this.ajustarQuantidade(linha);
        }
        linha.quantidadeTexto = this.formatarQuantidade(linha.quantidade);
        this.verificarItem(linha);
      },
      aoDigitarValor(linha, evento) {
        linha.valorTexto = evento.target.value;
        linha.valor = this.converter(evento.target.value);
      },
      aoSairDoValor(linha) {
        linha.valor = this.arredondar(linha.valor);
        linha.valorTexto = linha.valor > 0 ? this.formatar(linha.valor) : '';
        if (linha.idItem > 0) this.ajustarQuantidade(linha);
        this.verificarItem(linha);
      },
      converter(texto) {
        const limpo = (texto || '').replace(/[^0-9,.-]/g, '').replace(/\./g, '').replace(',', '.');
        return this.arredondar(+limpo || 0);
      },
      usarSaldo(linha) {
        const sobra = this.arredondar((+linha.valor || 0) + this.saldo);
        linha.valor = sobra > 0 ? sobra : 0;
        linha.valorTexto = linha.valor > 0 ? this.formatar(linha.valor) : '';
        if (linha.idItem > 0) this.ajustarQuantidade(linha);
        this.verificarItem(linha);
      },
    },
  }
</script>

<template>
  <div class="rt-bloco">
    <div class="rt-topo">
      <span class="rt-titulo">{{ titulo }}<span v-if="!opcional && !desabilitado && !semProjetos" class="rt-obr"> *</span></span>
      <span v-if="!desabilitado && !semProjetos && value.length > 0" class="rt-resumo" :class="{ 'rt-resumo-ok': fechou, 'rt-resumo-falta': !fechou }">
        {{ formatar(rateado) }} de {{ formatar(total) }}
        <template v-if="!fechou"> · falta {{ formatar(saldo) }}</template>
      </span>
    </div>

    <div v-if="desabilitado" class="rt-vazio">{{ aviso }}</div>

    <div v-else-if="semProjetos" class="rt-vazio">
      Esta conta não tem projeto vinculado — o lançamento nasce sem rateio.
    </div>

    <div v-else class="rt-grade">
      <div v-if="opcional && value.length === 0" class="rt-vazio rt-vazio-sem">
        Sem rateio — o lançamento nasce sem projeto. Use <b>Adicionar projeto</b> se quiser ratear.
      </div>

      <div v-if="value.length > 0" class="rt-cab" :class="{ 'rt-com-item': mostrarItem, 'rt-com-qtde': mostrarQuantidade }">
        <span>Projeto</span>
        <span>Rubrica</span>
        <span>Subrubrica</span>
        <span v-if="mostrarItem" class="rt-centro" title="Item de controle">CI</span>
        <span v-if="mostrarQuantidade" class="rt-dir">Qtde</span>
        <span class="rt-dir">Valor</span>
        <span></span>
      </div>

      <div v-for="(linha, indice) in value" :key="indice" class="rt-linha"
           :class="{ 'rt-com-item': mostrarItem, 'rt-com-qtde': mostrarQuantidade }">
        <div class="rt-celula" :class="{ 'rt-erro': validar && !linha.idProjeto }">
          <selecao-busca v-model="linha.idProjeto" :texto="linha.nomeProjeto" :buscar="buscarProjetos"
                         :placeholder="projetosLivres ? 'Buscar projeto...' : 'Projetos desta conta...'"
                         @selecionado="o => aoEscolherProjeto(linha, o, indice)"></selecao-busca>
        </div>
        <div class="rt-celula" :class="{ 'rt-erro': validar && linha.idProjeto && !linha.idRubrica }">
          <selecao-busca ref="rubrica" v-model="linha.idRubrica" :texto="linha.nomeRubrica"
                         :buscar="t => buscarRubricas(linha, t)" :desabilitado="!linha.idProjeto"
                         placeholder="Rubrica..." :auto-unico="true"
                         @selecionado="o => aoEscolherRubrica(linha, o, indice)"></selecao-busca>
        </div>
        <div class="rt-celula" :class="{ 'rt-erro': validar && linha.idRubrica && !linha.idSubRubrica }" :style="estiloSubrubrica(linha)">
          <selecao-busca ref="subrubrica" v-model="linha.idSubRubrica" :texto="linha.nomeSubrubrica"
                         :buscar="t => buscarSubrubricas(linha, t)" :desabilitado="!linha.idRubrica"
                         placeholder="Subrubrica..." :auto-unico="true"
                         @selecionado="o => aoEscolherSubrubrica(linha, o)"></selecao-busca>
        </div>
        <div v-if="mostrarItem && linha.exigeItem" class="rt-celula" :class="{ 'rt-erro': validar && linha.idSubRubrica && !(linha.idItem > 0) }">
          <button type="button" class="rt-ci" :class="{ 'rt-ci-item': linha.idItem > 0, 'rt-ci-recusado': linha.idItem > 0 && linha.erroItem }"
                  :disabled="!linha.idSubRubrica" :title="tituloCi(linha)" @click="abrirCi(linha)">
            <i class="fa fa-cube"></i>
          </button>
        </div>
        <div v-if="mostrarQuantidade && linha.exigeItem" class="rt-celula">
          <input v-if="linha.idItem > 0" type="text" class="form-control rt-qtde" :value="linha.quantidadeTexto"
                 @input="aoDigitarQuantidade(linha, $event)" @blur="aoSairDaQuantidade(linha)" placeholder="1">
        </div>
        <div class="rt-celula rt-celula-valor" :class="{ 'rt-erro': validar && !((+linha.valor || 0) > 0) }">
          <input type="text" class="form-control rt-valor" :value="linha.valorTexto"
                 @input="aoDigitarValor(linha, $event)" @blur="aoSairDoValor(linha)" placeholder="0,00">
          <button v-if="!fechou" type="button" class="rt-saldo" @click="usarSaldo(linha)"
                  title="Jogar o que falta nesta linha"><i class="fa fa-level-down"></i></button>
        </div>
        <div class="rt-celula rt-celula-acao">
          <button v-if="value.length > 1 || opcional" type="button" class="rt-remover" @click="remover(indice)"
                  title="Remover projeto"><i class="fa fa-trash-o"></i></button>
        </div>
        <div v-if="mostrarItem && linha.exigeItem && linha.idItem > 0" class="rt-ci-faixa"
             :class="{ 'rt-com-item': mostrarItem, 'rt-com-qtde': mostrarQuantidade, 'rt-ci-faixa-erro': !!linha.erroItem }">
          <span class="rt-ci-seta"></span>
          <button type="button" class="rt-ci-balao" title="Trocar o item de controle" @click="abrirCi(linha)">
            <i class="fa fa-cube"></i>
            <span>
              {{ linha.nomeItem }}
              <small v-if="linha.erroItem" class="rt-ci-erro"><i class="fa fa-ban"></i> {{ linha.erroItem }}</small>
            </span>
          </button>
        </div>
      </div>

      <div class="rt-rodape">
        <button type="button" class="rt-add" @click="adicionar"><i class="fa fa-plus"></i> Adicionar projeto</button>
        <span v-if="validar && mensagem" class="rt-msg">{{ mensagem }}</span>
      </div>
    </div>

    <item-controle-escolha v-if="ciLinha" :linha="ciLinha" :id-conta-cript="idContaCript"
                           :natureza="natureza" :com-quantidade="comQuantidade" :id-lancamento-ignorado="idLancamentoIgnorado"
                           :texto-sugestao="textoSugestao"
                           @escolher="aoEscolherCi" @fechar="ciLinha = null"></item-controle-escolha>
  </div>
</template>

<style scoped>
  .rt-bloco { margin-top: 10px; }
  .rt-topo { display: flex; align-items: baseline; justify-content: space-between; margin-bottom: 4px; }
  .rt-titulo { font-size: 12px; font-weight: 600; color: #34495e; }
  .rt-obr { color: #c0392b; }
  .rt-erro >>> .form-control { border-color: #ED5565; background: #fff; }
  .rt-resumo { font-size: 11px; font-weight: 600; }
  .rt-resumo-ok { color: #27865b; }
  .rt-resumo-falta { color: #b9552c; }
  .rt-vazio { font-size: 12px; color: #7b8794; background: #f7f9fb; border: 1px dashed #d5dde5;
              border-radius: 4px; padding: 10px 12px; }
  .rt-vazio-sem { border: none; background: transparent; padding: 9px 10px; }
  .rt-grade { border: 1px solid #e3e8ef; border-radius: 4px; background: #fff; }
  .rt-cab, .rt-linha { display: grid; grid-template-columns: minmax(0,2.2fr) minmax(0,1.6fr) minmax(0,1.6fr) 122px 26px;
                       gap: 6px; align-items: center; }
  .rt-cab.rt-com-item, .rt-linha.rt-com-item, .rt-ci-faixa.rt-com-item {
    grid-template-columns: minmax(0,2.2fr) minmax(0,1.6fr) minmax(0,1.6fr) 44px 122px 26px; }
  .rt-cab.rt-com-item.rt-com-qtde, .rt-linha.rt-com-item.rt-com-qtde, .rt-ci-faixa.rt-com-item.rt-com-qtde {
    grid-template-columns: minmax(0,2.1fr) minmax(0,1.5fr) minmax(0,1.5fr) 44px 68px 122px 26px; }
  .rt-centro { text-align: center; }
  .rt-cab { padding: 5px 8px; font-size: 10px; text-transform: uppercase; letter-spacing: .04em;
            color: #8b97a5; background: #f7f9fb; border-bottom: 1px solid #e3e8ef; }
  .rt-linha { padding: 6px 8px; border-bottom: 1px solid #f0f3f7; }
  .rt-linha:last-of-type { border-bottom: 0; }
  .rt-celula { min-width: 0; }
  .rt-celula-valor { position: relative; }
  .rt-dir { text-align: right; }
  .rt-valor { text-align: right; padding-right: 22px; }
  .rt-qtde { text-align: right; }
  .rt-na { color: #b0bac5; font-size: 12px; padding-left: 4px; }
  .rt-ci { display: flex; align-items: center; justify-content: center; width: 34px; height: 34px; margin: 0 auto; padding: 0;
           border: 1px solid #d2d6db; border-radius: 2px; background: #fff; color: #8a939c; font-size: 14px; }
  .rt-ci:hover:not(:disabled) { background: #f5f8fb; border-color: #8a939c; }
  .rt-ci:disabled { background: #eee; cursor: not-allowed; }
  .rt-ci-item { color: #1e7d4f; border-color: #a9d4b6; background: #f1f9f4; }
  .rt-ci-item:hover:not(:disabled) { background: #e5f2ea; border-color: #1e7d4f; }
  .rt-erro .rt-ci { border-color: #ED5565; color: #c0392b; background: #fdf3f3; }
  .rt-ci-faixa { grid-column: 1 / -1; display: grid; column-gap: 6px; margin-top: -3px; }
  .rt-ci-seta { grid-column: 4; grid-row: 1; justify-self: center; position: relative; z-index: 1; width: 0; height: 0; margin-bottom: -1px;
                border-left: 10px solid transparent; border-right: 10px solid transparent; border-bottom: 10px solid #1e7d4f; }
  .rt-ci-seta::after { content: ''; position: absolute; left: -9px; top: 1.5px; border-left: 9px solid transparent;
                       border-right: 9px solid transparent; border-bottom: 9px solid #f1f9f4; }
  .rt-ci-faixa:hover .rt-ci-seta::after { border-bottom-color: #e9f5ee; }
  .rt-ci-balao { grid-column: 1 / -1; grid-row: 2; display: flex; align-items: flex-start; gap: 7px; width: 100%; text-align: left;
                 background: #f1f9f4; border: 1px solid #1e7d4f; border-radius: 6px; padding: 6px 10px; font-size: 12px;
                 line-height: 1.45; color: #1c2024; cursor: pointer; }
  .rt-ci-balao .fa { color: #1e7d4f; margin-top: 2px; }
  .rt-ci-faixa:hover .rt-ci-balao { background: #e9f5ee; }
  .rt-ci-erro { display: block; margin-top: 3px; font-size: 11.5px; font-weight: 600; color: #a13c3c; }
  .rt-ci-recusado { color: #b23b3b; border-color: #e5b5b5; background: #fdf3f3; }
  .rt-ci-faixa-erro .rt-ci-seta { border-bottom-color: #b23b3b; }
  .rt-ci-faixa-erro .rt-ci-seta::after { border-bottom-color: #fdf3f3; }
  .rt-ci-faixa-erro .rt-ci-balao { border-color: #b23b3b; background: #fdf3f3; }
  .rt-ci-faixa-erro .rt-ci-balao .fa { color: #b23b3b; }
  .rt-ci-faixa-erro:hover .rt-ci-balao { background: #fbe9e9; }
  .rt-ci-faixa-erro:hover .rt-ci-seta::after { border-bottom-color: #fbe9e9; }
  .rt-saldo { position: absolute; right: 3px; top: 50%; transform: translateY(-50%); border: 0; background: none;
              color: #8b97a5; padding: 0 2px; font-size: 11px; cursor: pointer; }
  .rt-saldo:hover { color: #2f6fb2; }
  .rt-celula-acao { text-align: center; }
  .rt-remover { border: 0; background: none; color: #b0bac5; cursor: pointer; padding: 2px 4px; }
  .rt-remover:hover { color: #c0392b; }
  .rt-rodape { display: flex; align-items: center; justify-content: space-between; gap: 10px;
               padding: 6px 8px; border-top: 1px solid #e3e8ef; background: #fbfcfd; }
  .rt-add { border: 1px solid #cfd8e3; background: #fff; border-radius: 3px; color: #2f6fb2;
            font-size: 11px; padding: 3px 9px; cursor: pointer; }
  .rt-add:hover { border-color: #2f6fb2; }
  .rt-msg { font-size: 11.5px; font-weight: 600; color: #c0392b; }
  @media (max-width: 780px) {
    .rt-cab { display: none; }
    .rt-linha,
    .rt-linha.rt-com-item,
    .rt-linha.rt-com-item.rt-com-qtde { grid-template-columns: 1fr 1fr; }
    .rt-celula-acao { text-align: right; }
    .rt-linha > .rt-celula { grid-column: auto !important; }
    .rt-ci-faixa, .rt-ci-faixa.rt-com-item, .rt-ci-faixa.rt-com-item.rt-com-qtde { grid-template-columns: 1fr; margin-top: 0; }
    .rt-ci-seta { display: none; }
    .rt-ci { margin: 0; }
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/RateioProjetos.vue